module.exports = ".card-list:hover{\r\n    background-color: #FAFAFA;\r\n    border: #FEFEFE 1px outset;\r\n}"